import {apiService} from '@/lib/ApiService';
import {defaultMutationOptions} from '@/pages/_utils';
import {useMutation} from '@tanstack/react-query';
import useWorkflowStore from '../store';
import {useCallback} from 'react';
import TaskForm from '@/pages/resources/tasks/task-form';

export const useSaveWorkflow = (resource: 'projects' | 'tasks', id) => {
  const store = useWorkflowStore();

  const {nodes, edges, viewport, changes, timelineMarkers, clearChanges} = store;

  const saveWorkflow = useMutation({
    mutationKey: ['workflow-mutation', resource, String(id) || ''],
    mutationFn: async payload => {
      if (!id) return;
      return await apiService[resource].saveWorkflow(id, payload);
    },
    ...defaultMutationOptions,
  });

  const transformBeforeSave = nodes => {
    return nodes.map(node => {
      if (node.type === 'task') {
        return {
          ...node,
          data: TaskForm.transformBeforeSave(node.data),
        };
      }
      return node;
    });
  };

  const onSubmit = useCallback(async () => {
    const payload = {
      nodes: transformBeforeSave(nodes),
      edges,
      viewport,
      // remove extra data from timelineMarkers to prevent circular reference
      timelineMarkers: timelineMarkers.map(m => ({...m, extra: undefined})),
      changes: changes,
    };
    console.log('onSubmit save workflow', payload);
    await saveWorkflow.mutateAsync(payload, {
      onSuccess: () => {
        clearChanges();
      },
    });
  }, [saveWorkflow, nodes, edges, viewport, changes.nodes, clearChanges]);

  return {onSubmit, isSaving: saveWorkflow.isLoading};
};
